import { Switch } from 'antd';
import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { OfferType } from 'legacy/events/types';

const SaleThreshold = () => {
  const { t } = useTranslation('events');
  const { values, setFieldValue } = useFormikContext<OfferType>();
  const saleConditions = values.rewards.kickbackRewards.saleConditions;
  const isMinSalesThresholdEnabled = saleConditions?.minSalesThresholdEnabled;
  const hasActiveContract = values.contracts?.length > 0;
  return (
    <div className="mt-4">
      <div className="flex flex-row justify-between items-center">
        <div className="flex-1">
          <div className="text-sm font-bold text-[#575757] mb-2 leading-[18px]">
            {t('settings.promoterOffers.offerForm.minSalesThreshold')}
          </div>
          <div className="text-xs font-normal text-[#575757] mb-2 leading-[14px]">
            {t('settings.promoterOffers.offerForm.minSalesThresholdDescription')}
          </div>
        </div>
        <div>
          <Switch
            checked={isMinSalesThresholdEnabled}
            disabled={hasActiveContract}
            onChange={(checked) => {
              setFieldValue(
                'rewards.kickbackRewards.saleConditions.minSalesThresholdEnabled',
                checked
              );
            }}
          />
        </div>
      </div>
      <Field
        id="minSalesThreshold"
        name="minSalesThreshold"
        type="number"
        placeholder={t('settings.promoterOffers.offerForm.minSalesThresholdPlaceholder')}
        disabled={!isMinSalesThresholdEnabled || hasActiveContract}
        value={saleConditions?.minSalesThreshold || ''}
        onChange={(e) => {
          setFieldValue(
            'rewards.kickbackRewards.saleConditions.minSalesThreshold',
            Number(e.target.value)
          );
        }}
        className={classnames(
          'w-full border-1 border-[#DCDCDC] px-4 py-2 mx-auto h-12 rounded-md placeholder:text-[#B1B1B1] placeholder:text-sm placeholder:font-normal text-[#151515] text-sm font-normal ',
          {
            'opacity-50': !isMinSalesThresholdEnabled
          }
        )}
      />
    </div>
  );
};

export default SaleThreshold;
